
export * from '../../frontend-js-dependencies-web/__liferay__/exports/text-mask-core.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/text-mask-core.js';
export default __default__;
